
import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import LayoutNode, { getNodeComponentAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import { ContainerIcon } from "../Icons/ComponentIcons";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import React from "react";
import CreateAttributeList, { attributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { defaultDropList } from "../Data/WBComponentDefaults";
import WebDesigner from "../WebDesigner";
import { AttributeDefinition, AttributeInputType, CreateConditionalAttribute } from "../Data/WBData";
import { ApplyLinkAttributes as ApplyLinkAttributesToDomAtts, GetLinkFromLinkAttribute } from "vagaro-website-rendering/src/components/ComponentRenders/RenderButton";
import NodeCanBeLink from "../Utilities/NodeCanBeLink";



export default class WBContainer extends WBComponent {

    constructor() {
        super();
        this.typename = wBComponentTypeNames.container
        this.dropList = defaultDropList
        this.displayName = "Container";
        this.editList=[

          attributeTypes.flexDirection,
          attributeTypes.flexWrap,
          attributeTypes.justifyContent,
          attributeTypes.alignContent,
          attributeTypes.alignItems,
          "alignHorizontal",
          "justifyVertical",
          "justifyHorizontal",
          "alignVertical",
          // "isLink",
          'linkOpenType',
          // 'conditionalLinkOpenType',
          "cLink",
          ...CreateAttributeList(true,true,true,true,true)
        ];

        this.primaryEditAttributes = [

          attributeTypes.flexDirection,

       "alignment-full",

          attributeTypes.flexWrap,
          attributeTypes.gap,


          "cLink",
          'linkOpenType'


        ]

        this.icon = <ContainerIcon/>
    }




    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
      //thisLayout.componentAttributes = {horizontalAlign:"center",verticalAlign:"center"};
      setNodeStyleAttributeValue(thisLayout,ScreenSize.Desktop,attributeTypes.flexDirection,"row");
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {

      return [

        // CreateConditionalAttribute('conditionalLinkOpenType',"linkOpenType",[{key:"isLink",value:"true"}]),
        // new AttributeDefinition("linkOpenType","Link Open Type","",AttributeInputType.ButtonField,[{label:"Same Tab",value:"_self"},{label:"New Tab",value:"_blank"}]),
        new AttributeDefinition("alignment","Alignment","",AttributeInputType.ButtonField),
        // new AttributeDefinition("isLink","Act as Link","",AttributeInputType.ButtonField,[
        //   {label:"Off",value:""},
        //   {label:"On",value:"true"}
        // ]),
        new AttributeDefinition("cLink","Link","",AttributeInputType.LinkField)
      ]
    }



    RenderLayout({component,children,screenSize,isEditor,userContext}:WBRenderProps): JSX.Element {


      // const isLink = getNodeComponentAttributeValue(component,"isLink","");
      const lnk = getNodeComponentAttributeValue(component,"cLink","");
      const isLink = lnk.length>2 && getNodeComponentAttributeValue(component,"isLink","")=="true";
      const openType = getNodeComponentAttributeValue(component,"linkOpenType","_self")??"_self";




      if(  lnk&&lnk.length>0&&!isEditor&&isLink&&NodeCanBeLink(component)){

        const realLink = GetLinkFromLinkAttribute(lnk,userContext.pages);


        let scroll = realLink.startsWith("#")?"scroll-link":"";
        let isTele = realLink.startsWith("tel:")||realLink.startsWith("mailto:");
        let atts = GetNodeDomAttributes(`v-container no-a `+scroll +(isLink?" v-linked":""),component,screenSize,isEditor);

        let newAtts = ApplyLinkAttributesToDomAtts(lnk,component,atts);


        return <a  {...newAtts} href={realLink} target={isTele?"_blank":openType}  rel="noreferrer" >

          {children}
        </a>

      }



      return <div {...GetNodeDomAttributes(`v-container `+(isLink?" v-linked":""),component,screenSize,isEditor)}>

             {children}
          </div>
  }





}
